// Simplified Chinese
export const zhCN = {
  'nav.solutions': '直播解决方案',
  'nav.streamTemplates': '直播模板',
  "nav.prepare": "准备",
  "nav.events": "活动与直播",
  "nav.featurePresets": "功能预设",
  "nav.interact": "互动",
  "nav.boards": "互动白板",
  "nav.measure": "报告与商务",
  "nav.menu": "打开导航",
  "nav.closeMenu": "关闭导航",

  'app.name':           'Kardolive',
  'app.tagline':        '客户门户',
  'app.signOut':        '退出登录',

  'login.email':        '电子邮箱',
  'login.password':     '密码',
  'login.signIn':       '登录',
  'login.signingIn':    '正在登录…',
  'login.failed':       '登录失败',
  'login.newAccount':   '初次使用 Kardolive?',
  'login.createAccount':'创建免费账户 →',

  'nav.workspace':      '工作区',
  'nav.templates':      '模板',
  'nav.live':           '直播',
  'nav.rooms':          '房间与聊天',
  'nav.content':        '内容',
  'nav.developer':      '开发者',
  'nav.account':        '账户',

  'nav.overview':       '概览',
  'nav.projects':       '项目',
  'nav.chat':           '聊天控制台',
  'nav.sessions':       '会话',
  'nav.streams':        '直播',
  'nav.studio':         '工作室',
  'nav.recordings':     '录像',
  'nav.apiKeys':        'API 密钥',
  'nav.webhooks':       'Webhook',
  'nav.webhookTester':  'Webhook 测试器',
  'nav.networkTest':    '网络测试',
  'nav.embed':          '嵌入小部件',
  'nav.sdk':            'SDK 与文档',
  'nav.docs':           '开发者文档',
  'nav.analytics':      '分析',
  'nav.settings':       '设置',

  'overview.welcome':       '欢迎回来,{name}',
  'overview.plan':          '{tenant} · {plan} 套餐',
  'overview.newStream':     '新建直播',
  'overview.kpi.live':           '正在直播',
  'overview.kpi.live.broadcasting': '场直播进行中',
  'overview.kpi.live.nothing':    '暂无直播',
  'overview.kpi.total':           '直播总数',
  'overview.kpi.total.sub':       '所有时段',
  'overview.kpi.sessions':        '会话 · 近30天',
  'overview.kpi.sessions.sub':    '推流事件',
  'overview.kpi.recordings':      '录像',
  'overview.kpi.recordings.sub':  '可播放',
  'overview.recentStreams':       '最近的直播',
  'overview.recentSessions':      '最近的会话',
  'overview.viewAll':             '查看全部 →',
  'overview.empty.title':         '暂无直播',
  'overview.empty.body':          '创建您的第一个直播以开始推流。',
  'overview.empty.action':        '创建直播',
  'overview.noSessions':          '暂无会话',

  'status.live':        '直播中',
  'status.idle':        '空闲',
  'status.ended':       '已结束',
  'status.archived':    '已归档',

  'common.save':        '保存',
  'common.cancel':      '取消',
  'common.delete':      '删除',
  'common.edit':        '编辑',
  'common.create':      '创建',
  'common.confirm':     '确认',
  'common.loading':     '加载中…',
  'common.error':       '错误',
  'common.retry':       '重试',

  // Dashboard navigation and account controls.
  "nav.skipContent": "跳转到页面内容",
  "nav.scenarios": "应用场景",
  "nav.premieres": "首播",
  "nav.clips": "片段",
  "dashboard.account": "账户",
  "dashboard.language": "语言",
  "dashboard.appearance": "外观",
  "nav.allStreams": "全部直播",
  "nav.destinations": "转播目标",
  "nav.ecommerce": "电子商务",
  "nav.products": "商品",
  "nav.services": "服务",
  "nav.collections": "商品系列",
  "nav.orders": "订单",
  "nav.commerceSettings": "商务设置",
  "nav.engagement": "互动",
  "theme.light": "切换到浅色模式",
  "theme.dark": "切换到深色模式",
  "role.owner": "所有者",
  "role.admin": "管理员",
  "role.member": "成员",
  "role.viewer": "查看者",

  // Live Stream page content: never translate stored event names or API values.
  "streams.active": "使用中",
  "streams.archived": "已归档",
  "streams.monitor": "信号监测",
  "streams.create": "创建直播",
  "streams.list": "列表",
  "streams.grid": "网格",
  "streams.view": "直播视图",
  "streams.searchLabel": "搜索活动",
  "streams.searchHint": "搜索活动名称",
  "streams.solutionFilter": "按直播类型筛选活动",
  "streams.statusFilter": "按状态筛选活动",
  "streams.dateFilter": "按创建日期筛选活动",
  "streams.allSolutions": "全部直播类型",
  "streams.custom": "现有或自定义设置",
  "streams.allStatuses": "全部状态",
  "streams.anyTime": "不限创建时间",
  "streams.last7": "最近 7 天创建",
  "streams.last30": "最近 30 天创建",
  "streams.count": "显示 {shown} 个活动，共 {total} 个",
  "streams.noMatch": "没有符合筛选条件的活动。",
  "streams.clearFilters": "清除筛选",
  "streams.refreshFailed": "无法刷新直播列表",
  "streams.loadFailed": "无法加载直播",
  "streams.stale": "当前显示上次加载的列表，直播状态可能已改变。",
  "streams.connectionHint": "请检查网络连接，然后重新加载列表。",
  "streams.retrying": "正在重试…",
  "streams.retry": "重试",
  "streams.restoreFailed": "无法恢复直播",
  "streams.restoreHint": "请检查网络连接并刷新列表，确认最新状态后再试。",
  "streams.unused": "未使用的直播：{count}",
  "streams.unusedHint": "这些直播没有开播记录或回放。归档可整理列表，不会删除内容。",
  "streams.reviewArchive": "查看并归档",
  "streams.loading": "正在加载直播…",
  "streams.archiveEmpty": "暂无归档。已归档的直播及回放会保留在这里，直到恢复。",
  "streams.restore": "恢复",
  "streams.firstTitle": "创建您的第一个直播",
  "streams.firstBody": "选择销售、教学或服务设置，也可从空白直播开始。支持从浏览器、手机或 OBS 开播。",
  "streams.blank": "空白直播",
  "streams.broadcasts": "开播次数：{count}",
  "streams.replays": "回放：{count}",
  "streams.sessions": "会话：{count}",
  "streams.recordings": "录制：{count}",
  "streams.mode.BROADCAST": "广播",
  "streams.mode.LOW_LATENCY": "低延迟",
  "streams.mode.REALTIME": "实时",
  "streams.key": "密钥",
  "streams.archiveTitle": "归档未使用的直播",
  "streams.archiveHint": "这些直播从未开播。您可以随时从“已归档”标签页恢复。",
  "streams.archiveFailed": "有 {count} 个直播无法归档，可能已经开播。其余直播已归档。",
  "streams.archiving": "正在归档…",
  "streams.archiveCount": "归档 {count} 个",
  "streamType.webinar": "商务研讨会与发布会",
  "streamType.classroom": "课堂与辅导",
  "streamType.training": "企业培训",
  "streamType.conference": "会议与展览",
  "streamType.shopping": "直播购物",
  "streamType.auction": "直播拍卖",
  "streamType.consultation": "私人咨询",
  "streamType.creator": "创作者与社区直播",
  "streamType.audio": "语音房与播客",
  "streamType.sports": "体育与电竞",
  "streamType.performance": "音乐会与演出",
  "streamType.community": "宗教活动与募款",
  "streamType.tour": "导览与演示",
  "streamType.fitness": "健身与工作坊",
  "streamType.public-meeting": "新闻与公共会议",
  "streamType.continuous": "持续频道与摄像头",
  "streams.close": "关闭",
};
